import shellHttpClient from '@/shells/api/shellHttpClient';

export function normalizeNotificationPreview(payload = {}) {
  return {
    items: Array.isArray(payload.items) ? payload.items.map(item => ({
      id: String(item.id || ''),
      title: String(item.title || ''),
      createdAt: Number(item.created_at || 0),
      read: Boolean(item.read)
    })).filter(item => item.id) : [],
    unreadCount: Math.max(0, Number(payload.meta && payload.meta.unread_count) || 0)
  };
}

export class ModernNotificationsRepository {
  constructor(client = shellHttpClient) {
    this.client = client;
  }

  async getPreview(limit = 3) {
    const response = await this.client.get('/api/v1/eurekers-notifications/me', { params: { limit } });
    return normalizeNotificationPreview(response.data);
  }

  async markAllRead() {
    const response = await this.client.post('/api/v1/eurekers-notifications/me/read');
    return Math.max(0, Number(response.data && response.data.meta && response.data.meta.unread_count) || 0);
  }
}

export const modernNotificationsRepository = new ModernNotificationsRepository();
